export default "__VITE_ASSET__nVmcMqcu__"